/* Copy das configurações de plataforma (ADR-0704): domínios públicos, slugs e usernames
   reservados. Os cards em si (`ReservedSlugsCard` etc.) são de `../components/` — fora de escopo,
   traduzidos separadamente. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface PlatformSettingsContent {
  readonly pageTitle: string;
  readonly pageDescription: string;
  readonly emailDomainsTitle: string;
  readonly emailDomainsDescription: string;
  readonly reservedSlugsTitle: string;
  readonly reservedSlugsDescription: string;
  readonly reservedUsernamesTitle: string;
  readonly reservedUsernamesDescription: string;
  readonly forbiddenMessage: string;
}

const PLATFORM_SETTINGS_CONTENT: Bilingual<PlatformSettingsContent> = {
  'pt-BR': {
    pageTitle: 'Configurações da plataforma',
    pageDescription:
      'Proteção de namespace e onboarding — regras globais que valem para todas as organizações.',
    emailDomainsTitle: 'Domínios de e-mail públicos',
    emailDomainsDescription:
      'Barra o cadastro de empresas com domínios genéricos (gmail, outlook…).',
    reservedSlugsTitle: 'Slugs reservados',
    reservedSlugsDescription:
      'Namespaces protegidos do onboard self-service — só provisionáveis a um publisher pelo ' +
      'backoffice (anti-squatting).',
    reservedUsernamesTitle: 'Nomes de usuário reservados',
    reservedUsernamesDescription:
      'Handles (@username) que ninguém pode reivindicar — marcas, papéis e identidades do sistema.',
    forbiddenMessage: 'As configurações de plataforma são restritas a super administradores.',
  },
  'en-US': {
    pageTitle: 'Platform settings',
    pageDescription:
      'Namespace protection and onboarding — global rules that apply to every organization.',
    emailDomainsTitle: 'Public email domains',
    emailDomainsDescription: 'Blocks company sign-ups with generic domains (gmail, outlook…).',
    reservedSlugsTitle: 'Reserved slugs',
    reservedSlugsDescription:
      'Protected namespaces for self-service onboarding — only provisionable to a publisher ' +
      'through the backoffice (anti-squatting).',
    reservedUsernamesTitle: 'Reserved usernames',
    reservedUsernamesDescription:
      'Handles (@username) that no one can claim — brands, roles, and system identities.',
    forbiddenMessage: 'Platform settings are restricted to super administrators.',
  },
};

export const usePlatformSettingsContent = (): PlatformSettingsContent =>
  useBilingual(PLATFORM_SETTINGS_CONTENT);
